import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Checkbox, Label, TextField } from '@fluentui/react';
import { getGenericModal } from '../../../redux/selectors/ui';
import { ModalDocumentAction } from '../../../redux/actions/modal';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { ModalIds } from '../../../models/modal';

export interface DownloadProjectTransmittalOwnProps {
    modalId: ModalIds,
    showTransmittalId?: boolean,
}

interface DownloadProjectTransmittalStateProps {
    form?: {
        transmittalId?: string,
        exportParentFilesOnly?: boolean,
    }
}

interface DownloadProjectTransmittalDispatchProps {
    setContextItemProperty: typeof ModalDocumentAction.setContextItemProperty
}

type DownloadProjectTransmittalProps = DownloadProjectTransmittalOwnProps & DownloadProjectTransmittalStateProps & DownloadProjectTransmittalDispatchProps & RouteComponentProps & WithTranslation;

class DownloadProjectTransmittal extends React.Component<DownloadProjectTransmittalProps> {
    render(){
        const { form, modalId, setContextItemProperty, showTransmittalId, t } = this.props;

        return (
            <>
                {showTransmittalId &&
                    <TextField
                        label={t('Transmittal Id')}
                        autoComplete={'off'}
                        value={(form && form.transmittalId) || ''}
                        onChange={(e, value) => {
                            setContextItemProperty({id: modalId, name: 'transmittalId', value});
                        }}
                        styles={{root: {minWidth: 260}}}
                    />
                }
                <div style={{display: 'flex', alignItems: 'center', marginTop: showTransmittalId ? 12 : 0}}>
                    <Label styles={{root: {marginRight: 5}}}>{t('Do not download attachments/comments')}</Label>
                    <Checkbox
                        checked={(form && form.exportParentFilesOnly) ? form.exportParentFilesOnly : false}
                        onChange={(e, value) => {
                            setContextItemProperty({id: modalId, name: 'exportParentFilesOnly', value: value ? true : false});
                        }}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any, ownProps: DownloadProjectTransmittalOwnProps) => createStructuredSelector({
    form: (reduxState: any) => (getGenericModal(ownProps.modalId)(reduxState)) ? (getGenericModal(ownProps.modalId)(reduxState) as any).contextItem : undefined,
})(state);

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setContextItemProperty: ModalDocumentAction.setContextItemProperty
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(DownloadProjectTransmittal)));